import { FormikProps } from 'formik';
import React from 'react';

import { StandardField } from '@portals/autoformik';
import { FieldTypeEnum } from '@portals/types';

interface DeviceNameFieldProps {
  value: string;
  handleChange: FormikProps<any>['handleChange'];
  setFieldValue: FormikProps<any>['setFieldValue'];
  handleBlur: FormikProps<any>['handleBlur'];
}

export function DeviceNameField({
  value,
  handleChange,
  setFieldValue,
  handleBlur,
}: DeviceNameFieldProps) {
  return (
    <StandardField
      field={{
        type: FieldTypeEnum.Text,
        name: 'name',
        title: 'Name',
        required: true,
      }}
      disabled={false}
      readOnly={false}
      value={value}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      handleBlur={handleBlur}
    />
  );
}
